module.exports = __webpack_public_path__ + "static/media/fcloader_grey.3fe72b98.gif";